var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3409_3539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 23.4906H9.43254V47.1017H1V23.4906Z",
    fill: "#6B7CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4168 47.1016H12.8057V22.1363L17.936 14.4407L19.3611 4.46165C19.4793 3.65935 19.8812 2.92601 20.4939 2.39471C21.1066 1.86341 21.8895 1.56936 22.7004 1.56592H22.9247C24.2662 1.56726 25.5523 2.10074 26.5009 3.0493C27.4494 3.99785 27.9829 5.28398 27.9842 6.62544V16.7445H41.4763C43.2648 16.7467 44.9794 17.4582 46.244 18.7228C47.5086 19.9875 48.2201 21.702 48.2223 23.4905V35.2961C48.2188 38.426 46.9738 41.4267 44.7606 43.6399C42.5474 45.8531 39.5467 47.0981 36.4168 47.1016Z",
    fill: "#6B7CFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3409_3539"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.565918)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/Icon 2.66b57d12d9c154c0570541a0e4c7c22d.svg";
export { ForwardRef as ReactComponent };